import { VALIDATION_ENUMS } from '../Common/validator';

export const defaultErrorData = {
  touched: false,
  error: false,
  message: '',
};

export const FORM_VALUE = {
  firstName: {
    id: 'firstName',
    label: 'First name',
    classes: 'w-1/2 pr-2 sm:w-full',
    placeholder: 'Your First name',
    validation: [VALIDATION_ENUMS.IS_REQUIRED],
    value: '',
    errors: defaultErrorData,
  },
  lastName: {
    id: 'lastName',
    label: 'Last name',
    classes: 'w-1/2 pl-2 sm:w-full',
    placeholder: 'Your Last name',
    validation: [VALIDATION_ENUMS.IS_REQUIRED],
    value: '',
    errors: defaultErrorData,
  },
  email: {
    id: 'email',
    label: 'Email ID',
    placeholder: 'Your Email ID',
    validation: [VALIDATION_ENUMS.IS_REQUIRED, VALIDATION_ENUMS.IS_EMAIL],
    value: '',
    errors: defaultErrorData,
  },
  phone: {
    id: 'phone',
    label: 'Phone number',
    classes: 'w-1/2 pr-2 sm:w-full',
    placeholder: 'Your Phone number',
    validation: [VALIDATION_ENUMS.IS_REQUIRED, VALIDATION_ENUMS.IS_PHONE],
    value: '',
    errors: defaultErrorData,
  },
  designation: {
    id: 'designation',
    label: 'Designation ',
    classes: 'w-1/2 pl-2 sm:w-full',
    placeholder: 'Your Designation',
    validation: [],
    value: '',
    errors: defaultErrorData,
  },
  companyName: {
    id: 'companyName',
    label: 'Company name',
    placeholder: 'Your Company name',
    validation: [],
    value: '',
    errors: defaultErrorData,
  },
};
